import { NgModule } from '@angular/core';
import { CountUpDirective } from './count-up.directive';

@NgModule({
  imports: [],
  declarations: [CountUpDirective],
  exports: [CountUpDirective]
})
export class CountUpModule { }
